module.exports = __webpack_public_path__ + "static/media/icono telefono whatsApp.b47cf486.svg";